import { MARQUEE } from "@/lib/content";

const Row = () =>
  MARQUEE.map((w) => (
    <span key={w} className="flex items-center gap-10 pr-10 shrink-0">
      <span className="font-display italic text-4xl sm:text-5xl text-white whitespace-nowrap">{w}</span>
      <img src="/brand/badge.png" alt="" className="w-10 h-10 object-contain" />
    </span>
  ));

export const Marquee = () => (
  <div className="bg-granate py-6 overflow-hidden" data-testid="services-marquee">
    <div className="flex w-max animate-marquee">
      <Row /><Row />
    </div>
  </div>
);
